import React from 'react';

import {GenericPaginatedList} from 'app/components/general/lists/GenericPaginatedList';
import {CompactProcedureListItem} from 'app/procedures/components/CompactProcedureListItem';
import {StoredProceduresFetcher} from 'app/procedures/datafetchers';
import {useRemoveTeamItem} from 'app/teams/api';
import {
  type ListItemProps,
  TeamListItem,
} from 'app/teams/components/TeamDetailPage/components/TeamListItem';
import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {gt} from 'app/utils/i18n';

import {AddNewTeamProcedureButton} from './AddNewTeamProcedureButton';

import type {ProcedureSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  onFetch: () => unknown;
};

type ProcedureListItemProps = ListItemProps<ProcedureSerializedType> & {
  team: TeamSerializedType;
};

export const TeamProceduresSubPage = ({team}: Props) => {
  const [removeTeamItem] = useRemoveTeamItem();

  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="col-auto ml-auto">
            <AddNewTeamProcedureButton team={team} />
          </div>
        </TeamPageFilterBarStructure>
      ) : null}

      <GenericPaginatedList
        ItemComponent={ProcedureListItem}
        FetcherComponent={StoredProceduresFetcher}
        paramsBuilder={() => ({
          team_id: team.id,
          ordering: 'name',
        })}
        noItemsMessage={(perms, NoResultsMessage) => (
          <NoResultsMessage head={gt('No procedures for this team')}>
            <AddNewTeamProcedureButton
              buttonClass="btn btn-outline-primary"
              placement="top"
              team={team}
            />
          </NoResultsMessage>
        )}
        customProps={() => ({
          team,
        })}
        customDispatchProps={() => ({
          remove: (
            team: TeamSerializedType,
            procedure: ProcedureSerializedType
          ) => removeTeamItem({teamURL: team.url, item: procedure}),
        })}
      />
    </div>
  );
};

const ProcedureListItem = ({
  object,
  team,
  remove,
  refetchList,
}: ProcedureListItemProps) => (
  <TeamListItem
    object={object}
    team={team}
    remove={remove}
    contentType={'procedure'}
    ListItem={CompactProcedureListItem}
    refetchList={refetchList}
  />
);
